import React, { useState, useRef, useEffect } from "react";
import { replace, useLocation, useNavigate } from "react-router-dom";
import { LoginContain, LoginFooter } from "../../style/Login/ForgotVerifyOtp";
import { Loader } from "../../utils/loader";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ForgotVerifyOTP, ForgotSendOTP } from "../../services/authServices";
import Logo from "../../assets/images/logo.png";

function ForgotVerifyOtp() {
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [timer, setTimer] = useState(60);
  const otpInputRefs = useRef([]);
  const [loading, setLoading] = useState(false);
  const [resending, setResending] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const userData = location.state?.data;
  const timerRef = useRef(null);
  const [isOtpComplete, setIsOtpComplete] = useState(false);


  useEffect(() => {
    if (timer > 0) {
      timerRef.current = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    } else {
      clearInterval(timerRef.current);
    }
    return () => clearInterval(timerRef.current);
  }, [timer]);

  
  const handleChange = (value, index) => {
    if (!/^\d*$/.test(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value.slice(0, 1);
    setOtp(newOtp);

    const complete = newOtp.every((digit) => digit.trim() !== "");
    setIsOtpComplete(complete);

    if (value && index < otpInputRefs.current.length - 1) {
      otpInputRefs.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      const newOtp = [...otp];
      newOtp[index] = "";
      setOtp(newOtp);

      const complete = newOtp.every((digit) => digit.trim() !== "");
      setIsOtpComplete(complete);

      if (!otp[index] && index > 0) {
        otpInputRefs.current[index - 1]?.focus();
      }
    }
  };

  const handleResend = async () => {
    try {
      setResending(true);
      setTimer(60); // Restart timer
      setOtp(["", "", "", "", "", ""]); // Clear OTP inputs
      setIsOtpComplete(false); // Disable Submit button
      otpInputRefs.current[0]?.focus(); // Focus on the first OTP input

      const payload = {
        adminId: userData.adminId,
      };

      const response = await ForgotSendOTP(payload);

      if (response.success) {
        toast.success("OTP resent successfully");
      } else {
        toast.error(response.message || "Failed to resend OTP");
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to resend OTP");
    } finally {
      setResending(false);
    }
  };

  const handleVerifyOtp = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);
      const enteredOtp = otp.join("");
      if (!enteredOtp.trim()) {
        toast.error("Please enter the OTP");
        return;
      }

      const payload = {
        adminId: userData.adminId,
        otp: enteredOtp,
      };

      const response = await ForgotVerifyOTP(payload);

      if (response.success) {
        toast.success("OTP verified successfully");
        setTimeout(() => {
          navigate("/new-password", {
            state: {
              data: {
                adminId: userData.adminId,  
                OTP: enteredOtp,          
              },
            },
          });
          
        }, 1000);
      } else {
        toast.error(response.message || "Invalid OTP");
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to verify OTP");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <ToastContainer />
      <LoginContain>
        <div className="LoginCard">
          <div className="LoginLogo">
            <img src={Logo} alt="logo"  loading="lazy" />
          </div>
          <div className="LoginTitle">
            <h4>Forgot Verify OTP</h4>
            <p>Enter the OTP sent to your registered email or phone number.</p>
          </div>
          <form onSubmit={handleVerifyOtp}>
            <div className="LoginGroup text-center">
              <label htmlFor="otp" className="forgot-label">
                Enter your OTP
              </label>
            </div>

            <div className="otp-input-container">
              {otp.map((digit, index) => (
                <input
                  key={index}
                  type="text"
                  maxLength="1"
                  value={digit}
                  onChange={(e) => handleChange(e.target.value, index)}
                  onKeyDown={(e) => handleKeyDown(e, index)}
                  ref={(el) => (otpInputRefs.current[index] = el)}
                  className="otp-input"
                />
              ))}
            </div>

            <div className="LoginGroup timer-resend-container">
              <span className="timer">
                {timer > 0 ? `Resend in: ${timer} seconds` : ""}
              </span>
              <span
                className={`resend-text ${timer === 0 ? "active" : "disabled"}`}
                onClick={timer === 0 && !resending ? handleResend : null}
              >
                Resend OTP
              </span>
            </div>

            <div className="LoginGroup LoginBtn">
              <button type="submit" disabled={!isOtpComplete || loading}>
                {loading ? <Loader /> : "Submit"}
              </button>
            </div>
          </form>
        </div>
      </LoginContain>
      <LoginFooter>
        <p>
          POWERED BY: <span>Manthan IT Solutions</span>
        </p>
      </LoginFooter>
    </>
  );
}

export default ForgotVerifyOtp;
